import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { SearchComponent } from "@/utils/search/types/searchComponent";

import { ProductSortContextProvider } from "./context/sort.context";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    return (
        <ProductSortContextProvider component={SearchComponent.PRODUCT_SORT}>
            {children}
        </ProductSortContextProvider>
    );
};

export { Base };
